export enum GiftType {
  OneTime = 1,
  Recurring = 2,
  PledgePayment = 3
}
